import { request } from "./httpClient";

function getBaseUrl(prefixKey) {
  const prefix = window.appConfig && window.appConfig[prefixKey];
  return process.env.REACT_APP_API_URL + prefix;
}

const cronStrategies = {
  getEntsoeData: () => {
    const url = new URL(`${getBaseUrl("cronPrefix")}entsoe`);
    return {
      url,
      method: "POST",
      timeoutKey: "universalTimeout",
    };
  },
  getCarbonIntensityData: () => {
    const url = new URL(`${getBaseUrl("cronPrefix")}carbon_intensity`);
    return {
      url,
      method: "POST",
      timeoutKey: "universalTimeout",
    };
  },
  getLoadForecast: () => {
    const url = new URL(`${getBaseUrl("cronPrefix")}load_forecast`);
    return {
      url,
      method: "POST",
      timeoutKey: 20000,
    };
  },
  getSolarForecast: () => {
    const url = new URL(`${getBaseUrl("cronPrefix")}pv_forecast`);
    return {
      url,
      method: "POST",
      timeoutKey: 20000,
    };
  },
  generateSchedule: () => {
    const url = new URL(`${getBaseUrl("cronPrefix")}minischedule`);
    return {
      url,
      method: "POST",
      timeoutKey: 20000,
    };
  },
  calculateKPIs: () => {
    const url = new URL(`${getBaseUrl("cronPrefix")}kpi_calculation`);
    return {
      url,
      method: "POST",
      timeoutKey: 20000,
    };
  },
};

function masterCronCall(cronKey) {
  const strategy = cronStrategies[cronKey];
  if (!strategy) {
    throw new Error(`No strategy found for ${cronKey}`);
  }
  const { url, method, timeoutKey, body } = strategy();
  const timeout = typeof timeoutKey === "number"
  ? timeoutKey
  : window.appConfig?.[timeoutKey];
  const options = { method };
  if (body !== undefined) {
    options.body = typeof body === "string" ? body : JSON.stringify(body);
  }
  return request(url.toString(), options, timeout);
}

export const cronApi = {
  triggerEntsoeData() {
    return masterCronCall("getEntsoeData");
  },
  triggerCarbonIntensityData() {
    return masterCronCall("getCarbonIntensityData");
  },
  triggerLoadForecast() {
    return masterCronCall("getLoadForecast");
  },
  triggerSolarForecast() {
    return masterCronCall("getSolarForecast");
  },
  triggerScheduleGeneration() {
    return masterCronCall("generateSchedule");
  },
  triggerKPICalculation() {
    return masterCronCall("calculateKPIs");
  },
};
